export const HOST = process.env.HOST;
export const S3_BASE_URL = process.env.S3_BASE_URL;
